import { render, staticRenderFns } from "./partnerDetail.vue?vue&type=template&id=74c0dc40&scoped=true&"
import script from "./partnerDetail.vue?vue&type=script&lang=js&"
export * from "./partnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./partnerDetail.vue?vue&type=style&index=0&id=74c0dc40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c0dc40",
  null
  
)

export default component.exports